import React, { FC, useEffect } from 'react';
import { Breadcrumbs, PageHeader } from '@plataforma-xvia/design-system-es';
import { Tooltip } from '@mui/material';
import { InfoOutlined, WarningAmberOutlined } from '@mui/icons-material';
import { FooterContainer } from '../modules/footer/footer.container';
import { MedicinesContainer } from '../modules/medicines/medicines.container';
import { ROUTES } from '../routes';
import { buildAppPath } from '../utils/basePath';

import styles from './Medicines.module.css';

const PADRONIZADO_TOOLTIP =
  'Esta página mostra os medicamentos Padronizados pelo Estado, ou seja, aqueles que fazem parte da lista oficial de atendimento da REMEME.';

const PADRONIZADO_NOTICE =
  'A identificação "Padronizado" confirma que o Estado oferta este medicamento dentro dos protocolos de saúde, mas não garante o estoque em tempo real na unidade.';

export const Medicines: FC = () => {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.scrollY !== 0) {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <>
      
      <PageHeader
        title={
          ((
            <>
              Consulta de medicamentos padronizados pelo estado
              <Tooltip
                title={PADRONIZADO_TOOLTIP}
                arrow
                enterTouchDelay={0}
                leaveTouchDelay={6000}
              >
                <InfoOutlined
                  className={styles.titleInfoIcon}
                  tabIndex={0}
                  role="img"
                  aria-label={PADRONIZADO_TOOLTIP}
                />
              </Tooltip>
            </>
          ) as unknown) as string
        }
        className={styles.pageHeader}
        breadcrumb={
          <Breadcrumbs
            tone="inverted"
            showBackButton
            items={[
              { name: 'Início', path: buildAppPath('/') },
              {
                name: 'Consulta de medicamentos padronizados pelo estado',
                path: buildAppPath(ROUTES.MEDICINES_LIST_PAGE),
              },
            ]}
          />
        }
      >
        <div className={styles.padronizadoNotice} role="note">
          <WarningAmberOutlined
            className={styles.padronizadoNoticeIcon}
            aria-hidden="true"
          />
          <p className={styles.padronizadoNoticeText}>
            <strong>Importante:</strong> {PADRONIZADO_NOTICE}
          </p>
        </div>
      </PageHeader>
      <MedicinesContainer />
      <FooterContainer />
    </>
  );
};
